// URL del backend de Siloe (Railway)
const SILOE_API = process.env.REACT_APP_API_BASE_URL || 'https://siloemanager-production-938c.up.railway.app';

// URL del frontend de Siloe (puede ser diferente al backend)
const SILOE_FRONTEND = process.env.REACT_APP_PORTAL_URL || 'https://siloe-frontend-production.up.railway.app';

export const API_ENDPOINTS = {
  LOGIN: `${SILOE_API}/auth/login/`,
};

export interface LoginResponse {
  access: string;
  refresh: string;
  user?: Record<string, unknown>;
}

export async function loginUser(email: string, password: string): Promise<LoginResponse> {
  let response: Response;
  try {
    response = await fetch(API_ENDPOINTS.LOGIN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
  } catch {
    throw new Error('No se pudo conectar con el servidor. Intenta de nuevo.');
  }

  if (response.status === 401 || response.status === 400) {
    throw new Error('Correo o contraseña incorrectos.');
  }

  if (!response.ok) {
    throw new Error('Error del servidor. Intenta más tarde.');
  }

  return response.json();
}

/**
 * Redirige al frontend de Siloe pasando los tokens via URL.
 * Siloe los almacena en su propio localStorage mediante /auth/callback.
 */
export function redirectToPortal(accessToken: string, refreshToken: string): void {
  const base = SILOE_FRONTEND.replace(/\/$/, '');
  const params = new URLSearchParams({
    access_token: accessToken,
    refresh_token: refreshToken,
    origin: window.location.origin,
  });
  window.location.href = `${base}/auth/callback?${params.toString()}`;
}
